import Vue from 'vue'
import Router from 'vue-router'
import index_1 from '@/index'
import pathIndex from '@/index_2'
import index3 from '@/index_3'
Vue.use(Router)

export default new Router({
  scrollBehavior(to, from, savedPosition) {
    // 解决路由跳转后 会滚动到底部
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },

  routes: [
    {
      path: '/',
      name: 'index_1',
      component: index_1
    },
    // {
    //   path: '/',
    //   name: 'index3',
    //   component: index3
    // },
    {
      path: '/pathIndex',
      name: 'pathIndex',
      component: pathIndex,

    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js